import fetch from 'isomorphic-fetch'

const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY
const API_URL_AVT = process.env.REACT_APP_AVT_API_URL

const toQuery = (params) =>
  Object.keys(params)
    .map((key) => encodeURIComponent(key) + '=' + encodeURIComponent(params[key]))
    .join('&')

const createRequestBody = (requestObj, fromData) => {
  return {
    method: requestObj.method,
    headers: requestObj.headers || {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: fromData ? requestObj.body : JSON.stringify(requestObj.body)
  }
}

const uploadFile = (body) => {
  const requestUrl = `${API_URL_AVT}/odin/api/uploadFile`

  const headers = {}
  let requestBody = createRequestBody(
    {
      method: 'POST',
      headers,
      body
    },
    true
  )
  return fetch(requestUrl, requestBody)
}

const getCapabilities = (_) => {
  const userInfo = JSON.parse(localStorage.getItem('user_info'))
  const clientId = userInfo?.user?.client?.clientNumber
  const requestUrl = `${API_URL_AVT}/nebula/capacity/capabilities?clientId=${clientId}`

  let requestBody = createRequestBody({
    method: 'GET'
  })
  return fetch(requestUrl, requestBody)
}

const getStoresByFleet = (fleetId) => {
  const requestUrl = `${API_URL_AVT}/nebula/capacity/fleets/${fleetId}/stores`

  let requestBody = createRequestBody({
    method: 'GET'
  })
  return fetch(requestUrl, requestBody)
}

const getFleets = (params = {}) => {
  const requestUrl = `${API_URL_AVT}/odin/api/capacity/retrieve/fleets`

  let requestBody = createRequestBody({
    method: 'POST',
    body: params
  })
  return fetch(requestUrl, requestBody)
}

const getCapacityContext = (fleetId, params) => {
  params['intervalLengthInMinutes'] = 60
  const requestUrl = `${API_URL_AVT}/nebula/capacity/fleetCapacityContext/${fleetId}?${toQuery(params)}`

  let requestBody = createRequestBody({
    method: 'GET'
  })
  return fetch(requestUrl, requestBody)
}

const getQuotasDetail = (fleetId, from, to) => {
  const query = from && to ? `?from=${from}&to=${to}` : ''
  const requestUrl = `${API_URL_AVT}/nebula/capacity/quotas-detail/${fleetId}${query}`

  let requestBody = createRequestBody({
    method: 'GET'
  })
  return fetch(requestUrl, requestBody)
}

const setQuotas = (fleetId, quotas) => {
  const requestUrl = `${API_URL_AVT}/odin/api/capacity/quotas`

  let requestBody = createRequestBody({
    method: 'POST',
    body: {
      fleetId,
      quotas
    }
  })
  return fetch(requestUrl, requestBody)
}

const createFleet = (fleet) => {
  const requestUrl = `${API_URL_AVT}/odin/api/capacity/fleets`

  let requestBody = createRequestBody({
    method: 'POST',
    body: {
      fleet
    }
  })
  return fetch(requestUrl, requestBody)
}

const updateFleet = (fleetId, fleet) => {
  const requestUrl = `${API_URL_AVT}/odin/api/capacity/fleet/${fleetId}`

  let requestBody = createRequestBody({
    method: 'PUT',
    body: {
      ...fleet
    }
  })
  return fetch(requestUrl, requestBody)
}

const availableQuotasQuantity = (data) => {
  const requestUrl = `${API_URL_AVT}/nebula/capacity/available-quotas-quantity/`

  let requestBody = createRequestBody({
    method: 'PUT',
    body: data
  })
  return fetch(requestUrl, requestBody)
}

const getFleetsStoresByClient = () => {
  const userInfo = JSON.parse(localStorage.getItem('user_info'))
  const clientId = userInfo?.user?.client?.clientNumber
  const requestUrl = `${API_URL_AVT}/nebula/capacity/${clientId}/fleets-stores?offset=0&limit=500`

  let requestBody = createRequestBody({
    method: 'GET'
  })
  return fetch(requestUrl, requestBody)
}

const getFleetsResources = (resourceId) => {
  const requestUrl = `${API_URL_AVT}/odin/api/capacity/fleets/${resourceId}`

  let requestBody = createRequestBody({
    method: 'GET'
  })
  return fetch(requestUrl, requestBody)
}

const getFleetsByResource = (resourceId, resource) => {
  const requestUrl = `${API_URL_AVT}/nebula/capacity/${resourceId}/fleetPermissions`

  const requestBody = createRequestBody({
    method: 'GET',
    body: resource
  })
  return fetch(requestUrl, requestBody)
}

const fleetsPermissions = (resourceId, resource) => {
  const requestUrl = `${API_URL_AVT}/odin/api/capacity/fleetPermissions/${resourceId}`

  const requestBody = createRequestBody({
    method: 'PUT',
    body: resource
  })
  return fetch(requestUrl, requestBody)
}

const createQuotasByResource = (fleetId, resourceId, quotas) => {
  const requestUrl = `${API_URL_AVT}/odin/api/capacity/quotas/create-by-resource`

  const requestBody = createRequestBody({
    method: 'POST',
    body: { fleetId, resourceId, quotas }
  })
  return fetch(requestUrl, requestBody)
}

const deleteQuotasByResource = (fleetId, resourceId, quotas) => {
  const requestUrl = `${API_URL_AVT}/odin/api/capacity/quotas/delete-by-resource`

  const requestBody = createRequestBody({
    method: 'PUT',
    body: { fleetId, resourceId, quotas }
  })
  return fetch(requestUrl, requestBody)
}

const bringVehicles = (limit = 50, offset = 0) => {
  const userInfo = JSON.parse(localStorage.getItem('user_info'))
  const clientId = userInfo?.user?.client?.clientNumber
  const requestUrl = `${API_URL_AVT}/nebula/vehicles?client_id=${clientId}&limit=${limit}&offset=${offset}`

  const requestBody = createRequestBody({
    method: 'GET'
  })
  return fetch(requestUrl, requestBody)
}

const getCityLatLong = async (city) => {
  const url = 'https://maps.googleapis.com/maps/api/geocode/json'
  const response = await fetch(`${url}?address=${city}&key=${GOOGLE_MAPS_API_KEY}`, {
    method: 'GET',
    headers: {
      Accept: 'application/json'
    }
  })
  if (response.ok) {
    const result = await response.json()
    const address = result.results[0]
    return address && address.geometry && address.geometry.location ? address.geometry.location : null
  }
  return null
}

const getTimezoneLatLong = async (latitude, longitude, time) => {
  const url = 'https://maps.googleapis.com/maps/api/timezone/json'
  const response = await fetch(
    `${url}?location=${latitude},${longitude}&timestamp=${time}&key=${GOOGLE_MAPS_API_KEY}`,
    {
      method: 'GET',
      headers: {
        Accept: 'application/json'
      }
    }
  )
  if (response.ok) {
    const result = await response.json()
    return result ? result : null
  }
  return null
}

const getInverseGeolocationData = async (lat, long) => {
  return fetch(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${long}&key=${GOOGLE_MAPS_API_KEY}`)
    .then((response) => response.json())
    .then((data) => {
      const { results } = data
      if (results.length) {
        return results
      } else {
        return []
      }
    })
    .catch((error) => {
      console.log(`Reverser Geocoding Error: ${error}`)
      return []
    })
}
const bringResources = (query, resourceStates) => {
  let queryParams = toQuery(query)
  if (resourceStates) {
    switch (resourceStates) {
      case 'all':
        queryParams = queryParams + '&states=OPERATIVE&states=DELETED'
        break
      case 'active':
        queryParams = queryParams + '&states=OPERATIVE'
        break
      case 'deleted':
        queryParams = queryParams + '&states=DELETED'
        break

      default:
        break
    }
  }

  const requestUrl = `${API_URL_AVT}/odin/api/resources?${queryParams}`
  const requestBody = createRequestBody({
    method: 'GET'
  })
  return fetch(requestUrl, requestBody)
}

const bringResource = (resourceId) => {
  const requestUrl = `${API_URL_AVT}/nebula/resources/${resourceId}`

  const requestBody = createRequestBody({
    method: 'GET'
  })
  return fetch(requestUrl, requestBody)
}

const getResources = async (query) => {
  const requestUrl = `${API_URL_AVT}/odin/api/resources?${toQuery(query)}`

  const requestBody = await createRequestBody({
    method: 'GET'
  })
  return fetch(requestUrl, requestBody)
}

const getResourceById = async (resourceId) => {
  const requestUrl = `${API_URL_AVT}/nebula/resources/${resourceId}`

  const requestBody = await createRequestBody({
    method: 'GET'
  })
  return fetch(requestUrl, requestBody)
}

const createResources = (resource) => {
  const requestUrl = `${API_URL_AVT}/odin/api/resources`

  const requestBody = createRequestBody({
    method: 'POST',
    body: {
      ...resource,
      phone_number: `${resource.prefix}${resource.phone_number}`
    }
  })
  return fetch(requestUrl, requestBody)
}

const updateResourcesById = (resource) => {
  const { id: resourceId, prefix, phone_number: phoneNumber } = resource
  const requestUrl = `${API_URL_AVT}/odin/api/resources/${resourceId}`

  const requestBody = createRequestBody({
    method: 'PUT',
    body: {
      ...resource,
      phone_number: `${prefix}${phoneNumber}`
    }
  })
  return fetch(requestUrl, requestBody)
}

const deleteResource = async (resourceId, eventType) => {
  const requestUrl = `${API_URL_AVT}/odin/api/resources/${resourceId}?eventType=${eventType}`

  const requestBody = createRequestBody({
    method: 'DELETE'
  })
  return fetch(requestUrl, requestBody)
}

const getStores = (params = {}) => {
  const requestUrl = `${API_URL_AVT}/odin/api/capacity/retrieve/stores`

  let requestBody = createRequestBody({
    method: 'POST',
    body: params
  })
  return fetch(requestUrl, requestBody)
}

const createStore = (store) => {
  const requestUrl = `${API_URL_AVT}/odin/api/capacity/stores`

  let requestBody = createRequestBody({
    method: 'POST',
    body: {
      ...store
    }
  })
  return fetch(requestUrl, requestBody)
}

const updateStore = ({ storeId, dataToUpdate }) => {
  const requestUrl = `${API_URL_AVT}/odin/api/capacity/store/${storeId}`

  let requestBody = createRequestBody({
    method: 'PUT',
    body: {
      ...dataToUpdate
    }
  })
  return fetch(requestUrl, requestBody)
}

const getCities = (_) => {
  const userInfo = JSON.parse(localStorage.getItem('user_info'))
  const clientId = userInfo?.user?.client?.clientNumber
  const requestUrl = `${API_URL_AVT}/nebula/capacity/cities?clientId=${clientId}`

  let requestBody = createRequestBody({
    method: 'GET'
  })
  return fetch(requestUrl, requestBody)
}

const getDepartments = (_) => {
  const userInfo = JSON.parse(localStorage.getItem('user_info'))
  const clientId = userInfo?.user?.client?.clientNumber
  const requestUrl = `${API_URL_AVT}/nebula/client/operation-parameters?client_id=${clientId}`

  let requestBody = createRequestBody({
    method: 'GET'
  })
  return fetch(requestUrl, requestBody)
}

const getPredefinedQuotasName = () => {
  const userInfo = JSON.parse(localStorage.getItem('user_info'))
  const clientId = userInfo?.user?.client?.clientNumber
  const requestUrl = `${API_URL_AVT}/nebula/predefined-quotas/names/${clientId}`

  let requestBody = createRequestBody({
    method: 'GET'
  })
  return fetch(requestUrl, requestBody)
}

const getPredefinedQuotas = (name) => {
  const userInfo = JSON.parse(localStorage.getItem('user_info'))
  const clientId = userInfo?.user?.client?.clientNumber
  const requestUrl = `${API_URL_AVT}/nebula/predefined-quotas/${clientId}?name=${name}`

  let requestBody = createRequestBody({
    method: 'GET'
  })
  return fetch(requestUrl, requestBody)
}

const assignMassiveQuotas = (data) => {
  const userInfo = JSON.parse(localStorage.getItem('user_info'))
  const clientId = userInfo?.user?.client?.clientNumber
  const requestUrl = `${API_URL_AVT}/nebula/predefined-quotas/assign/${clientId}`

  const requestBody = createRequestBody({
    method: 'POST',
    body: data
  })
  return fetch(requestUrl, requestBody)
}

const reactivateResourceById = async (resourceId, eventType) => {
  const requestUrl = `${API_URL_AVT}/odin/api/resources/reactivate/${resourceId}?eventType=${eventType}`

  const requestBody = createRequestBody({
    method: 'POST'
  })
  return fetch(requestUrl, requestBody)
}

const enableOrDisableFeaturesConfiguration = (body) => {
  const requestUrl = `${API_URL_AVT}/nebula/features-configuration`

  const requestBody = createRequestBody({
    method: 'POST',
    body
  })
  return fetch(requestUrl, requestBody)
}

const getFeaturesConfiguration = (id) => {
  const swapQuotas = 'SWAP_QUOTAS'
  const takeQuotas = 'TAKE_QUOTAS'
  const allowEditWantsToReceiveTasksByResource = 'ALLOW_EDIT_WANTS_TO_RECEIVE_TASKS_BY_RESOURCE'
  const queryParams = `fleet_id=${id}&feature_names=${swapQuotas}&feature_names=${takeQuotas}&feature_names=${allowEditWantsToReceiveTasksByResource}`

  const userInfo = JSON.parse(localStorage.getItem('user_info'))
  const clientId = userInfo?.user?.client?.clientNumber
  const requestUrl = `${API_URL_AVT}/nebula/features-configuration/${clientId}?${queryParams}`

  let requestBody = createRequestBody({
    method: 'GET'
  })
  return fetch(requestUrl, requestBody)
}
const getFeaturesConfigurationByStoreId = (storeId) => {
  const canUpdateTaskOptimals = 'CAN_UPDATE_TASKS_OPTIMALS'
  const queryParams = `store_id=${storeId}&feature_names=${canUpdateTaskOptimals}`

  const userInfo = JSON.parse(localStorage.getItem('user_info'))
  const clientId = userInfo?.user?.client?.clientNumber
  const requestUrl = `${API_URL_AVT}/nebula/features-configuration/${clientId}?${queryParams}`

  let requestBody = createRequestBody({
    method: 'GET'
  })
  return fetch(requestUrl, requestBody)
}

export {
  getDepartments,
  getStores,
  createStore,
  updateStore,
  getCities,
  createResources,
  updateResourcesById,
  deleteResource,
  bringResources,
  bringResource,
  getTimezoneLatLong,
  getCityLatLong,
  uploadFile,
  getFleets,
  getStoresByFleet,
  getCapacityContext,
  getQuotasDetail,
  setQuotas,
  getFleetsResources,
  getFleetsByResource,
  fleetsPermissions,
  createFleet,
  updateFleet,
  getCapabilities,
  createQuotasByResource,
  deleteQuotasByResource,
  bringVehicles,
  getPredefinedQuotasName,
  assignMassiveQuotas,
  availableQuotasQuantity,
  getFleetsStoresByClient,
  getResources,
  getResourceById,
  getPredefinedQuotas,
  reactivateResourceById,
  enableOrDisableFeaturesConfiguration,
  getFeaturesConfiguration,
  getFeaturesConfigurationByStoreId,
  getInverseGeolocationData
}
